module.exports = __webpack_public_path__ + "static/media/faq-video-thumbnail.760f88aa.png";